import Navbar from "./components/Navbar/Navbar";
import { Notes } from "./components/UI/Notes";
const App = () => {
  return (
    <div>
      <Navbar />
      <Notes />
    </div>
  );
};
export default App;
